<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Goleadores</span>
</mat-toolbar>

<div class="stats-scorers-page">
  @if (loading) {
    <div class="loading-state">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (scorers.length === 0) {
    <div class="empty-state">
      <mat-icon>sports_soccer</mat-icon>
      <p>Todavía no hay goleadores registrados.</p>
    </div>
  } @else {
    @for (scorer of scorers; track scorer.player.id; let i = $index) {
      <article class="scorer-card">
        <div class="scorer-rank">{{ i + 1 }}</div>

        <img
          class="team-crest"
          [src]="scorer.team.crest"
          [alt]="scorer.team.shortName || scorer.team.name"
        />

        <div class="scorer-copy">
          <div class="scorer-name">{{ scorer.player.name }}</div>
          <div class="scorer-team">
            {{ scorer.team.shortName || scorer.team.name }}
            @if (scorer.team.tla) {
              <span>· {{ scorer.team.tla }}</span>
            }
            @if (getPlayerAge(scorer.player.dateOfBirth); as age) {
              <span>· {{ age }} años</span>
            }
          </div>
        </div>

        <div class="scorer-stats">
          <strong>{{ scorer.goals }}</strong>
          <span>{{ scorer.goals === 1 ? "gol" : "goles" }}</span>
        </div>

        <div class="scorer-extra">
          <span>{{ scorer.playedMatches }} PJ</span>
          @if (scorer.penalties) {
            <span>{{ scorer.penalties }} pen.</span>
          }
        </div>
      </article>
    }
  }
</div>
